import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { ButtonRegresar } from "../../components/ButtonRegresar";
import { fetchAxiosToken } from "../../helpers/fetchAxiosToken";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { ButtonSiguiente } from "./ButtonSiguiente";
import nombreAlojamiento from "../../img/onboarding/nombra_alojamiento.jpg";

import { useDispatchDominio } from "../../hooks/useDispatchDominio";
import { fetchAxiosNoToken } from "../../helpers/fetchAxiosNoToken";
import { set_landing_house } from "../../redux/reducers/landingReducer";
export const NombreCasa = ({ corredor = false }: { corredor?: boolean }) => {
    const {
        nombre,
        id: id_casa,
        plan,
        tipo_calendario,
        tipo_inmueble,
    } = useAppSelector((state) => state.landing_house.house);
    const dispatch = useAppDispatch();
    const { idCasa } = useParams();
    const dispatchDominio = useDispatchDominio(
        idCasa && Number(idCasa) > 0 ? idCasa : undefined
    );
    const [input, setInput] = useState({
        nombre: nombre,
        tipo_calendario: tipo_calendario,
        tipo_inmueble: tipo_inmueble,
    });
    const { id: id_usuario } = useAppSelector((state) => state.usuario_logeado);

    const navigate = useNavigate();

    const handleInputChange = (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
    ) => {
        setInput({
            ...input,
            [e.target.name]: e.target.value,
        });
    };

    useEffect(() => {
        setInput({
            nombre: nombre,
            tipo_calendario: tipo_calendario,
            tipo_inmueble: tipo_inmueble,
        });
    }, [nombre]);

    useEffect(() => {
        if (idCasa && Number(idCasa) > 0) dispatchDominio();
    }, []);
    console.log("id_casa", id_casa);
    const handleSubmit = async () => {
        if (!input.nombre) {
            return Swal.fire({
                title: "Debes escoger un nombre válido",
                icon: "warning",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
            });
        }

        try {
            if (idCasa && Number(idCasa) > 0) {
                await fetchAxiosToken({
                    url: `/casa/putNombre/${idCasa}`,
                    method: "put",
                    body: {
                        nombre: input.nombre,
                        tipo_calendario: corredor
                            ? input.tipo_calendario
                            : null,
                        tipo_inmueble: corredor ? input.tipo_inmueble : null,
                    },
                });

                await fetchAxiosToken({
                    url: `/casa/putPagina/${idCasa}`,
                    method: "put",
                    body: {
                        pagina:
                            input.tipo_inmueble === "terreno"
                                ? "tema"
                                : "capacidad",
                    },
                });
                console.log("casa actualizada");
                dispatchDominio();
                navigate(
                    `/dashboard-corredor/onboarding/${
                        input.tipo_inmueble === "terreno" ? "tema" : "capacidad"
                    }/${idCasa}`
                );
            } else if (id_casa) {
                await fetchAxiosToken({
                    url: `/casa/putNombre/${id_casa}`,
                    method: "put",
                    body: {
                        nombre: input.nombre,
                        tipo_calendario: corredor
                            ? input.tipo_calendario
                            : null,
                        tipo_inmueble: corredor ? input.tipo_inmueble : null,
                    },
                });

                await fetchAxiosToken({
                    url: `/casa/putPagina/${id_casa}`,
                    method: "put",
                    body: {
                        pagina: "capacidad",
                    },
                });
                dispatchDominio();

                if (plan > 0) {
                    navigate(`/dashboard/onboarding/capacidad`);
                } else {
                    navigate(`/dashboard/onboarding/suscripcion`);
                }
            } else {
                const data = await fetchAxiosToken({
                    url: `/casa`,
                    method: "post",
                    body: {
                        id_propietario: id_usuario,
                        nombre: input.nombre,
                        tipo_calendario: corredor
                            ? input.tipo_calendario
                            : null,
                        tipo_inmueble: corredor ? input.tipo_inmueble : null,
                    },
                });

                await fetchAxiosToken({
                    url: `/casa/putPagina/${data.data.id}`,
                    method: "put",
                    body: {
                        pagina:
                            input.tipo_inmueble === "terreno"
                                ? "tema"
                                : "capacidad",
                    },
                });

                !idCasa && dispatchDominio();
                navigate(
                    idCasa
                        ? `/dashboard-corredor/onboarding/${
                              input.tipo_inmueble === "terreno"
                                  ? "tema"
                                  : "capacidad"
                          }/${data.data.id}`
                        : plan > 0
                        ? `/dashboard/onboarding/capacidad`
                        : `/dashboard/onboarding/suscripcion`
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="flex flex-col h-screen grid-cols-2 lg:grid">
            <div className="block h-56 md:h-1/3 lg:h-auto bg-black/80">
                <div className="relative flex flex-col items-center justify-center h-full text-center lg:h-screen">
                    <img
                        src={nombreAlojamiento}
                        alt="nombreAlojamiento"
                        className="w-full h-full"
                    />
                    <div className="absolute top-0 w-full h-full bg-black opacity-40 "></div>
                    <div className="absolute top-0 flex flex-col items-center justify-center w-2/3 h-full 0">
                        <div className="text-2xl font-bold text-center text-white md:text-4xl 2xl:text-6xl ">
                            Escoge un nombre para tu{" "}
                            {corredor ? "Inmueble" : "alojamiento"}
                        </div>

                        <div className="mt-5 text-lg text-center text-white md:text-xl 2xl:text-2xl md:mt-14 ">
                            ¡No te preocupes podrás cambiarlo más adelante!
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative flex flex-col justify-center h-screen p-3 text-center text-black bg-white">
                <ButtonRegresar
                    url={`${
                        idCasa
                            ? "/dashboard-corredor/inmuebles"
                            : "/dashboard/onboarding/bienvenida"
                    }`}
                    className="absolute top-10 left-10"
                    arrowColor="black"
                    textColor="black"
                />
                <div className="flex flex-col items-start justify-center w-3/4 mx-auto md:w-2/3 lg:w-1/2">
                    <h1 className="w-full text-lg font-medium text-center">
                        Nombre:
                    </h1>
                    <input
                        type={"text"}
                        name="nombre"
                        value={input.nombre}
                        onChange={handleInputChange}
                        placeholder="ej. casa rosales"
                        className="w-full p-3 mt-4 text-black border border-gray-500 rounded-lg placeholder:italic"
                    />

                    {corredor && (
                        <div className="flex flex-col w-full mt-4">
                            <label className="mt-4 text-lg font-medium">
                                Este inmueble sera para:
                            </label>
                            <select
                                name="tipo_calendario"
                                value={input.tipo_calendario || ""}
                                onChange={handleInputChange}
                                className="w-full p-3 mt-2 text-black border border-gray-500 rounded-lg placeholder:italic">
                                <option value="">Selecciona un tipo</option>
                                <option value="alquiler">Alquilar</option>
                                <option value="alquiler vacacional">
                                    Alquiler vacacional
                                </option>

                                <option value="venta">Vender</option>
                            </select>
                            {input.tipo_calendario === "alquiler" && (
                                <p className="mt-2 text-sm text-gray-600">
                                    Si eliges este modo, tus huespedes agendaran
                                    una visita para ver el inmueble.
                                </p>
                            )}
                            {input.tipo_calendario ===
                                "alquiler vacacional" && (
                                <p className="mt-2 text-sm text-gray-600">
                                    Si eliges este modo, tus huéspedes podrán
                                    reservar alquileres por tiempo corto.
                                </p>
                            )}
                            <label className="text-lg font-medium">
                                Tipo de inmueble:
                            </label>
                            <select
                                name="tipo_inmueble"
                                value={input.tipo_inmueble || ""}
                                onChange={handleInputChange}
                                className="w-full p-3 mt-2 text-black border border-gray-500 rounded-lg placeholder:italic">
                                <option value="">Selecciona un tipo</option>
                                <option value="casa">Casa</option>
                                <option value="departamento">
                                    Departamento
                                </option>
                                {input.tipo_calendario !==
                                    "alquiler vacacional" && (
                                    <>
                                        <option value="terreno">Terreno</option>
                                        <option value="local comercial">
                                            Local comercial
                                        </option>
                                        <option value="oficina">Oficina</option>
                                    </>
                                )}
                            </select>
                        </div>
                    )}

                    <ButtonSiguiente onSubmit={() => handleSubmit()} />
                </div>
            </div>
        </div>
    );
};
